<div>
	<mat-toolbar>
		<button [disableRipple]="true" matDialogClose class="close" mat-icon-button>
			<mat-icon>cancel</mat-icon>
		</button>
	</mat-toolbar>
	<mat-dialog-content style="max-width: 340px; min-width: 250px; width: auto; height: auto; padding: 0px">
		<div class="image-section" color="primary">
			<div class="action-content">
				<div class="action-image">
					<img src="assets/images/horse.png" />
				</div>
				<div class="action-title">
					<h2>CART BEFORE HORSE</h2>
				</div>
				<div class="action-message">
					<h5>
						You need to create a channel before you can post to it!
						<br />
						Let us show you how.
					</h5>
				</div>
			</div>
		</div>
	</mat-dialog-content>
	<mat-dialog-actions align="center">
		<button [disableRipple]="true" mat-flat-button [mat-dialog-close]="true" (click)="startTour()" cdkFocusInitial color="primary">Open tutorial</button>
	</mat-dialog-actions>
</div>
